/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDocumentPin = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M14.414 2H4v20h7v-2H6V4h7v5h5v1h2V7.586zm2.172 5H15V5.414z" />
        <path d="m14.682 18.904-2.39 2.389 1.415 1.414 2.39-2.389L17.776 22l.805-.814V18.84l2.027-2.056 1.205.391L23 16.002 19 12l-1.164 1.182.382 1.22-2.036 2.018h-2.4l-.782.8z" />
      </g>
    </g>
  </Icon>
);
export { SvgDocumentPin as DocumentPin };
